import { isNull } from "@tsparticles/engine";
import { PolygonMaskMoveType } from "../../Enums/PolygonMaskMoveType.js";
export class PolygonMaskMove {
    constructor() {
        this.radius = 10;
        this.type = PolygonMaskMoveType.path;
    }
    load(data) {
        if (isNull(data)) {
            return;
        }
        if (data.radius !== undefined) {
            this.radius = data.radius;
        }
        if (data.type !== undefined) {
            this.type = data.type;
        }
    }
}
